import React, { Fragment, useCallback, useContext, useMemo, useState } from "react";

import UIPopupContext from "../../popups/UIPopup/UIPopupContext";
import {editPrompt} from "../aiApi";
import UiPopupAIContentEditingModal from "./UiPopupAIContentEditingModal";

const UiPopupAIContentPrompts = (props) => {

  const {type} = props;

  const {uiPopupContext, uiPopupDispatch} = useContext(UIPopupContext);
  const {promptsList} = uiPopupContext;

  const [isEditingPrompt, setIsEditingPrompt] = useState(false);

  const isActiveType = "isActive" + type;

  const activePrompt = useMemo(() => {
    if (!promptsList) return null;
    return promptsList.find((promptObject) => promptObject[isActiveType]);
  }, [promptsList, isActiveType]);

  const openEditor = useCallback(() => {
    if (!activePrompt) return;
    setIsEditingPrompt(true);
  }, [activePrompt]);

  const closeEditor = useCallback(
    async (newValue) => {
      setIsEditingPrompt(false);
      if (!activePrompt) return;

      // 1) update prompt body in context
      uiPopupDispatch({
        promptsList: promptsList.map((p) => {
          if (p.id === activePrompt.id) {
            return { ...p, promptBody: newValue };
          }
          return p;
        }),
      });

      // 2) persist
      await editPrompt({ ...activePrompt, promptBody: newValue });
    },
    [activePrompt, promptsList, uiPopupDispatch]
  );

  if (!promptsList || !activePrompt) return null;

  return (
    <Fragment>
      {/* Preview textarea (small) */}
      <textarea
        className="h-full w-full ui-input"
        value={activePrompt.promptBody || ""}
        readOnly
        onFocus={openEditor}
        onClick={openEditor}
      />
      <UiPopupAIContentEditingModal
        propsOpened={isEditingPrompt}
        propsTitle={type + " Prompt"}
        propsValue={activePrompt?.promptBody || ""}
        propsClose={closeEditor}
      />
    </Fragment>
  );
};

export default UiPopupAIContentPrompts;
